import { render, staticRenderFns } from "./AffiliateShareV2Form.vue?vue&type=template&id=0100d6f0&scoped=true"
import script from "./AffiliateShareV2Form.vue?vue&type=script&lang=js"
export * from "./AffiliateShareV2Form.vue?vue&type=script&lang=js"
import style0 from "./AffiliateShareV2Form.vue?vue&type=style&index=0&id=0100d6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0100d6f0",
  null
  
)

export default component.exports